/* eslint-disable camelcase */
import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import { pageSelector } from 'selectors/page/pageSelector';
import superChatActions from 'ai/actions/superChatActions';
import sdnApi from 'ai/services/sdn';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocaleResourceFile } = LanguageLocaleUtils;
const getText = getLocaleResourceFile('ai/components/EntryPoint/locales', 'AIChat');

const { entryPointPrompts } = sdnApi;

const PAGE = 'SRP';
const localization = createStructuredSelector({
    new: getTextFromResource(getText, 'new'),
    newChatHeadingPlp: getTextFromResource(getText, 'newChatHeadingPlp'),
    aiChatInputPlaceholderPlp: getTextFromResource(getText, 'aiChatInputPlaceholderPlp'),
    aiChatInputPlaceholderPlpLgUi: getTextFromResource(getText, 'aiChatInputPlaceholderPlpLgUi')
});

const functions = (dispatch, _ownProps) => ({
    fetchEntryPointPromptsPlp: async nthCategory => {
        const { categories } = nthCategory || {};
        const categoryId = categories?.[0]?.categoryId || '';
        const searchTerm = categories?.[0]?.displayName || '';

        return entryPointPrompts({ categoryId, searchTerm, page: PAGE }).then(data => data);
    },
    handlePromptClick: (prompts, nthCategory, products) => {
        const { categories } = nthCategory || {};
        const categoryId = categories?.[0]?.categoryId || '';

        const data = {
            entrypoint: 'PLP',
            category_id: categoryId,
            products: products
                ?.filter(product => product.currentSku)
                ?.slice(0, 30)
                .map(product => ({
                    product_id: product.productId,
                    sku_id: product.currentSku.skuId
                }))
        };
        dispatch(superChatActions.showSuperChat(true, prompts, data));
    }
});

const fields = createSelector(localization, pageSelector, (locales, page) => {
    return {
        localization: locales,
        nthCategory: page?.nthCategory || {}
    };
});

const withProductListPageProps = wrapHOC(connect(fields, functions));

export {
    withProductListPageProps, fields, functions
};
